import React from 'react';
import { Route, Switch } from "react-router-dom";
import HomePage from './Components/HomePage';
import AppliedRoute from "./Components/AppliedRoute";
import ErrorPage from "./Containers/ErrorPage";
import ConfirmationPage from "./Components/ConfirmationPage";
import AppointmentFeedback from "./Components/AppointmentFeedback";
import CaseDetails from './Components/CaseDetails';

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute path="/" exact component={HomePage} props={childProps} />
    {/* <AppliedRoute path="/bookappointment" exact component={HomePage} props={childProps} /> */}
    <AppliedRoute path="/appointment" exact component={ConfirmationPage} props={childProps} />
    <AppliedRoute path="/appointmentFeedback" exact component={AppointmentFeedback} props={childProps} />
    <AppliedRoute path="/CaseDetails" exact component={CaseDetails} props={childProps} />
    <Route component={ErrorPage} />
  </Switch>
);